<template>
  <div>
    <modal-crear-editar
      :configuracion="configuracion_modal"
      @realizado="restablecer_inputs"
    ></modal-crear-editar>
    <tablita
      @cargar="cargar($event)"
      @cargar_url="cargar_url($event)"
      @nuevo="crear"
      @editar="editar($event)"
      :configuracion="configuracion_tabla"
      @editar_parametros="editar_parametros($event)"
      @refresh="refrescar($event)"
      :cols="columnas"
    ></tablita>

    <!-- Modal Configuracion Parametros-->
    <div
      class="modal fade"
      id="modal_parametros"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered modal-xl" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">
              Lista de Parametros
              <strong>{{
                item_actual ? item_actual.nombre_materia_prima : ""
              }}</strong>
            </h5>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <table class="table table-bordered">
              <thead>
                <tr>
                  <th class="text-center">ID</th>

                  <th class="text-center">Parametro</th>
                  <!-- <th class="text-center">Minimo</th>
                      <th class="text-center">Maximo</th>-->
                  <th class="text-center">Parametro Padre</th>
                  <th class="text-center">Configurar Alertas</th>
                  <th class="text-center">Configurar Usuarios Correo</th>
                  <th class="text-center">Configurar Fórmula</th>
                </tr>
              </thead>
              <tr v-for="p in parametros_item" :key="p.id">
                <td>{{ p.id }}</td>

                <td>{{ p.parametro_texto }}</td>
                <!-- <td>
                      <input type="number" name="" id="" v-model="p.valor_minimo">
                    </td>
                    <td>
                      <input type="number" name="" id="" v-model="p.valor_maximo">
                    </td>-->
                <td>
                  <select
                    name=""
                    id=""
                    v-model="p.lab_item_parametros_id"
                    @change="actualizar_lab_item_parametro(p)"
                  >
                    <option value="">--Ninguno--</option>
                    <option
                      :value="i.id"
                      v-for="i in devolver_parametros(
                        p.item_analisis.mp_tipos_id
                      )"
                      :key="i.id"
                    >
                      {{ i.nombre }}
                    </option>
                  </select>
                </td>
                <td class="text-center">
                  <button
                    class="btn btn-danger btn-sm"
                    @click="configurar_alertas(p)"
                  >
                    <i class="fas fa-exclamation-triangle"></i>
                  </button>
                </td>
                <td class="text-center">
                  <button
                    class="btn btn-primary btn-sm"
                    @click="configurar_usuarios_correo(p)"
                  >
                    <i class="fas fa-users"></i>
                  </button>
                </td>
                <td class="text-center">
                  <button
                    class="btn btn-warning btn-sm"
                    @click="configurar_formula(p)"
                  >
                    <i class="fas fa-calculator"></i>
                  </button>
                </td>
              </tr>
            </table>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary"
              data-dismiss="modal"
            >
              Cerrar
            </button>
            <!-- <button type="button" class="btn btn-primary">Save changes</button> -->
          </div>
        </div>
      </div>
    </div>

    <!-- Modal Configuracion Alertas-->
    <div
      class="modal fade"
      id="modal_alertas"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered modal-xl" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">
              Configuracion de Alertas
              <strong
                >{{
                  parametro_actual ? parametro_actual.parametro_texto : ""
                }}
                ({{
                  item_actual ? item_actual.nombre_materia_prima : ""
                }})</strong
              >
            </h5>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <!-- <div :class="`alert ${alert_modal_correo_clase} alert-dismissible fade show`" role="alert" v-show="alert_modal_correo">
                    <span class="alert-icon"><i class="ni ni-like-2"></i></span>
                    <span class="alert-text"><strong></strong> {{alert_modal_correo_mensaje}}</span>
                    <button type="button" class="close" @click="alert_modal_correo = !alert_modal_correo" aria-label="Close">
                        <span aria-hidden="true" class="cruz">&times;</span>
                    </button>
                </div> -->
            <div class="row">
              <div class="col">
                <button
                  class="btn btn-success btn-sm float-right"
                  @click="agregar_alerta()"
                >
                  <i class="fas fa-plus"></i> Agregar
                </button>
              </div>
            </div>

            <div class="row">
              <div class="col fixTableHead">
                <table class="table table-bordered">
                  <thead>
                    <tr>
                      <th class="text-center">Id</th>
                      <th class="text-center">Minimo</th>
                      <th class="text-center">Maximo</th>
                      <th class="text-center" width="300px">Empresas</th>
                      <th class="text-center">Eliminar</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(a, idx) in alertas" :key="idx">
                      <td>{{ a.id }}</td>
                      <td class="text-center">
                        <input type="number" name="" id="" v-model="a.minimo" />
                      </td>
                      <td class="text-center">
                        <input type="number" name="" id="" v-model="a.maximo" />
                      </td>
                      <td class="text-center">
                        <v-select
                          class=""
                          :reduce="(option) => option.id"
                          v-model="a.empresas_ids"
                          :options="empresas"
                          label="nombre"
                          multiple
                        >
                          <template v-slot:no-options="{ search, searching }">
                            <template v-if="searching">
                              No se Encontraron Resultados Para
                              <em>{{ search }}</em
                              >.
                            </template>
                            <em style="opacity: 0.5" v-else
                              >Escriba para Filtrar...</em
                            >
                          </template>
                        </v-select>
                      </td>
                      <td class="text-center">
                        <button
                          class="btn btn-danger btn-sm"
                          @click="eliminar_alerta(a, idx)"
                        >
                          <i class="fas fa-trash"></i>
                        </button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>

            <!-- <pre>{{parametro_actual}}</pre> -->
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary btn-sm"
              data-dismiss="modal"
            >
              Cerrar
            </button>
            <button
              type="button"
              class="btn btn-success btn-sm"
              @click="guardar_alertas()"
            >
              <i class="fas fa-save"></i> Guardar
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal Configuracion Destinatarios Correo-->
    <div
      class="modal fade"
      id="modal_destinatarios"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered modal-xl" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">
              Configuracion de Destinatarios
              <strong
                >{{
                  parametro_actual ? parametro_actual.parametro_texto : ""
                }}
                ({{
                  item_actual ? item_actual.nombre_materia_prima : ""
                }})</strong
              >
            </h5>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col fixTableHead">
                <table class="table table-bordered">
                  <thead>
                    <tr>
                      <th class="text-center">Nombre</th>
                      <th class="text-center">Correo</th>
                      <th class="text-center">Asignar</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(d, idx) in destinatarios_correos" :key="idx">
                      <td>{{ d.nombre }}</td>
                      <td>{{ d.correo }}</td>
                      <td>
                        <input
                          type="checkbox"
                          name=""
                          id=""
                          :value="d.id"
                          v-model="d.check"
                        />
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary btn-sm"
              data-dismiss="modal"
            >
              Cerrar
            </button>
            <button
              type="button"
              class="btn btn-success btn-sm"
              @click="guardar_destinatarios()"
            >
              <i class="fas fa-save"></i> Guardar
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal Configuracion Formula de Parámetro-->
    <div
      class="modal fade"
      id="modal_formula"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered modal-xl" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">
              Configurar Fórmula para el Parámetro
              <strong
                >{{
                  parametro_actual ? parametro_actual.parametro_texto : ""
                }}
                ({{
                  item_actual ? item_actual.nombre_materia_prima : ""
                }})</strong
              >
            </h5>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col">
                <button
                  class="btn btn-success btn-sm float-right"
                  @click="agregar_paso_formula()"
                >
                  <i class="fas fa-plus"></i> Agregar
                </button>
              </div>
            </div>
            <div class="row">
              <div class="col fixTableHead table-responsive">
                <table class="table table-bordered">
                  <thead>
                    <tr>
                      <th class="text-center">Tipo Valor 1</th>
                      <th class="text-center">Valor 1</th>
                      <th class="text-center">Parámetro 1</th>
                      <th class="text-center">Operador</th>
                      <th class="text-center">Tipo Valor 2</th>
                      <th class="text-center">Valor 2</th>
                      <th class="text-center">Parámetro 2</th>
                      <th class="text-center">Orden</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(p, idx) in pasos_formula" :key="idx">
                      <td>
                        <select name="" id="" v-model="p.tipo_valor_1">
                          <option
                            v-for="t in tipo_valores"
                            :key="t.id"
                            :value="t.id"
                          >
                            {{ t.valor }}
                          </option>
                        </select>
                      </td>
                      <td>
                        <input
                          type="number"
                          name=""
                          id=""
                          v-model="p.valor_1"
                        />
                      </td>

                      <td>
                        <select
                          name=""
                          id=""
                          v-model="p.lab_item_parametros_id1"
                        >
                          <option
                            v-for="par in parametros_mp"
                            :key="par.id"
                            :value="par.id"
                          >
                            {{ par.parametro_completo }}
                          </option>
                        </select>
                      </td>

                      <td>
                        <select name="" id="" v-model="p.operador">
                          <option
                            v-for="o in operadores"
                            :key="o.id"
                            :value="o.id"
                          >
                            {{ o.valor }}
                          </option>
                        </select>
                      </td>

                      <td>
                        <select name="" id="" v-model="p.tipo_valor_2">
                          <option
                            v-for="t in tipo_valores"
                            :key="t.id"
                            :value="t.id"
                          >
                            {{ t.valor }}
                          </option>
                        </select>
                      </td>
                      <td>
                        <input
                          type="number"
                          name=""
                          id=""
                          v-model="p.valor_2"
                        />
                      </td>

                      <td>
                        <select
                          name=""
                          id=""
                          v-model="p.lab_item_parametros_id2"
                        >
                          <option
                            v-for="par in parametros_mp"
                            :key="par.id"
                            :value="par.id"
                          >
                            {{ par.parametro_completo }}
                          </option>
                        </select>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary btn-sm"
              data-dismiss="modal"
            >
              Cerrar
            </button>
            <button
              type="button"
              class="btn btn-success btn-sm"
              @click="guardar_formula()"
            >
              <i class="fas fa-save"></i> Guardar
            </button>
          </div>
        </div>
      </div>
    </div>
    <pre>{{ tipo_valores }}</pre>
  </div>
</template>
<script>
import { mapActions, mapState } from "vuex";
import ModalCrearEditar from "../../components/Modal/ModalEditarCrear";
import Tabla from "../../components/Tabla/Tabla";
//import lenguaje from '../../config/es_datatable.json'
export default {
  data: () => ({
    filter: "",
    columnas: [
      {
        key: "id",
        label: "Id",
        busqueda: "",
        tipo: "number",
        searchable: false,
        path: "id",
      },
      {
        key: "nombre",
        label: "Nombre",
        busqueda: "",
        tipo: "string",
        searchable: true,
        path: "nombre",
      },
      //{key:'mp_tipos_id',label:'Materia Prima',busqueda:'',tipo:'select',searchable:true,path:'materia_prima_texto',opciones:[],valor_opcion:'id',label_opcion:'nombre'},
      //{key:'orden',label:'Orden',busqueda:'',tipo:'number',searchable:true,path:'orden'},
      //{key:'activo',label:'Activo',busqueda:'',tipo:'number',searchable:true,path:'activo_texto'},
    ],
    botones: [
      {
        label: "Configurar Parametros",
        clase: "btn-primary",
        evento: "editar_parametros",
        icono: "fa fa-list",
      },
      {
        label: "Editar",
        clase: "btn-warning",
        evento: "editar",
        icono: "fa fa-pen",
      },
    ],
    lista: [],
    links: [],
    inputs: [
      { cols: 6, tipo: "texto", key: "nombre", valor: "", label: "Nombre (*)" },
      //{cols:6,tipo:'select',key:'mp_tipos_id',valor:'',label:'Materia Prima (*)',opciones:[],valor_opcion:'id',label_opcion:'nombre'},
      //{cols:6,tipo:'numero',key:'orden',valor:'',label:'Orden'},
      //{cols:6,tipo:'checkbox',key:'activo',valor:true,label:'Activo'},
      //{cols:12,tipo:'v-select_multiple',key:'lab_parametros_ids',valor:'',label:'Parametros de Medición (Activos)',opciones:[],label_opcion:'nombre'}
    ],
    configuracion_modal: {
      titulo: "Registrar Item Análisis",
      ancho: "xl",
      ruta: "/lab_item_analisis",
      tipo_ruta: "post",
      titulo_boton: "Crear",
      clase_boton: "btn-success",
    },
    configuracion_tabla: {
      titulo: "Listado de Items de Análisis",
      titulo_boton: "Crear Item Análisis",
      clase_boton: "btn-primary",
      btn_nuevo: true,
    },
    pagina_actual: "",
    materias_primas: [],
    parametros: [],
    parametros_item: [],
    item_actual: null,
    usuarios: [],
    usuarios_ids: [],
    parametro_actual: null,
    alert_modal_correo: false,
    alert_modal_correo_mensaje: "",
    alert_modal_correo_clase: "alert-success-1",
    alertas: [],
    empresas: [],
    destinatarios_correos: [],
    destinatarios_ids: [],
    lab_item_parametros: [],
    /**configuracion de formulas */
    tipo_valores: [],
    operadores: [],
    parametros_mp: [],
    pasos_formula: [],
  }),
  mounted() {
    //this.cargar_lab_item_parametros();
    this.inicializar_tabla({
      columnas: [],
      lista: [],
      links: [],
      botones: [],
      botones_restringidos: [],
    });
    let storage = localStorage.getItem(this.path);
    if (storage) {
      storage = JSON.parse(storage);
      this.columnas.forEach((col) => {
        col.busqueda = storage.columnas.find((c) => c.key == col.key).val;
      });
    }
    //this.cargar("");
    this.$emit("cargar");
  },
  methods: {
    refrescar() {
      localStorage.removeItem(this.path);
      this.columnas.forEach((c) => {
        if (
          [
            "string",
            "number",
            "select",
            "select-loadable",
            "select-loadable-dependiente",
            "datetime",
            "html",
            "html_select",
          ].includes(c.tipo)
        ) {
          c.busqueda = "";
        }

        if (["multiselect"].includes(c.tipo)) {
          c.busqueda = [];
        }
      });
      this.$emit("cargar");
    },
    async actualizar_lab_item_parametro(p) {
      await this.axios
        .put(`${this.api}/lab_item_parametros/${p.id}`, p, this.cabeceras_json)
        .then((res) => {
          //console.log('actualizado',res.data.data);
        })
        .catch((e) => {
          //console.log(e);
        });
    },

    devolver_parametros(mp_tipos_id) {
      return this.lab_item_parametros
        .filter((p) => p.item_analisis.mp_tipos_id == mp_tipos_id)
        .map((p) => {
          return {
            id: p.id,
            nombre: `${p.id} - ${p.parametro_texto} (${p.item_analisis_texto})`,
          };
        });
    },

    async cargar_lab_item_parametros() {
      await this.axios
        .get(`${this.api}/lab_item_parametros?limit=99999`, this.cabeceras_json)
        .then(async (res) => {
          this.lab_item_parametros = res.data.data.data;
          await this.resetear_destinatarios_correos();
        })
        .catch((e) => {
          //console.log(e);
        });
      this.cargar_destinatarios();
    },

    async cargar_destinatarios() {
      await this.axios
        .get(`${this.api}/destinatarios?limit=99999`, this.cabeceras_json)
        .then(async (res) => {
          this.destinatarios_correos = res.data.data.data;
          await this.resetear_destinatarios_correos();
        })
        .catch((e) => {
          //console.log(e);
        });
      this.cargar_empresas();
    },

    async cargar_empresas() {
      await this.axios
        .get(
          `${this.api}/empresas?tipo_empresa_ids=4&limit=999999999`,
          this.cabeceras_json
        )
        .then((res) => {
          this.empresas = res.data.data.data;
        })
        .catch((e) => {
          //alert(e);
        });
      this.cargar_materias_primas();
    },
    async cargar_materias_primas() {
      await this.axios
        .get(`${this.api}/mps_tipo?limit=999999999`, this.cabeceras_json)
        .then((res) => {
          this.materias_primas = res.data.data.data;
          this.inputs[1].opciones = this.materias_primas;
          this.columnas[2].opciones = this.materias_primas;
        })
        .catch((e) => {
          //console.log(e);
        });
      this.cargar_parametros();
    },

    async cargar_parametros() {
      await this.axios
        .get(`${this.api}/lab_parametros?limit=999999999`, this.cabeceras_json)
        .then((res) => {
          this.parametros = res.data.data.data;
          this.inputs[4].opciones = this.parametros;
          //this.columnas[1].opciones = this.materias_primas;
        })
        .catch((e) => {
          //console.log(e);
        });
      this.cargar_tipo_valores();
      //this.cargar_usuarios();
    },

    async cargar_tipo_valores() {
      await this.axios
        .get(
          `${this.api}/configuracion_formulas/cargar_tipo_valor`,
          this.cabeceras_json
        )
        .then((res) => {
          this.tipo_valores = res.data.data;
        })
        .catch((e) => {
          //console.log(e);
        });
      this.cargar_operadores();
      //this.cargar_usuarios();
    },

    async cargar_operadores() {
      await this.axios
        .get(
          `${this.api}/configuracion_formulas/cargar_operadores`,
          this.cabeceras_json
        )
        .then((res) => {
          this.operadores = res.data.data;
        })
        .catch((e) => {
          //console.log(e);
        });
      this.cargar("");
      //this.cargar_usuarios();
    },

    /* async cargar_usuarios(){
          await this.axios.get(`${this.api}/usuarios?habilitado_romana2=1&limit=999999999`,this.cabeceras_json).then((res)=>{
            this.usuarios = res.data.data.data;
          }).catch((e)=>{
            //console.log(e);
          })
          this.cargar('');
        }, */

    async guardar_parametro(p) {
      let body = {
        valor_minimo: p.valor_minimo,
        valor_maximo: p.valor_maximo,
      };
      await this.axios
        .put(
          `${this.api}/lab_item_parametros/${p.id}`,
          body,
          this.cabeceras_json
        )
        .then((res) => {
          this.cargar("");
        })
        .catch((e) => {
          //console.log(e);
        });
    },

    async cargar($event) {
      this.pagina_actual = `${this.api}/lab_item_analisis${$event}`;
      this.lista = [];
      await this.axios
        .get(`${this.api}/lab_item_analisis${$event}`, this.cabeceras_json)
        .then((res) => {
          this.lista = res.data.data.data;
          this.links = res.data.data.links;
          /* let config = {
                  columnas:this.columnas,
                  lista:this.lista,
                  links:this.links
                } */
          this.inicializar_tabla({
            columnas: this.columnas,
            lista: this.lista,
            links: this.links,
            botones: this.botones,
          });
          //this.$emit('generar',this.columnas,this.lista);
          ////console.log('listado',res.data.data.data);
        })
        .catch((e) => {
          //alert(e);
        });
    },
    async cargar_url(url) {
      if (url) {
        this.pagina_actual = url;
        await this.axios
          .get(url, this.cabeceras_json)
          .then((res) => {
            this.lista = res.data.data.data;
            this.links = res.data.data.links;
            ////console.log('listado',res.data.data.data);
            this.setear_lista({ lista: this.lista, links: this.links });
            //$('#empresas').DataTable().draw();
          })
          .catch((e) => {
            //alert(e);
          });
      }
    },
    crear() {
      this.setear_inputs(this.inputs);
      this.configuracion_modal.ruta = `/lab_item_analisis`;
      this.configuracion_modal.tipo_ruta = "post";
      this.configuracion_modal.titulo_boton = "Crear";
      this.configuracion_modal.clase_boton = "btn-success";

      this.$emit("abrir", { inputs: this.inputs });
    },
    editar(evento) {
      //console.log('evento',evento);
      let item = evento.item;
      this.inputs.forEach((i) => {
        //recorrido del objeto a editar
        Object.keys(item).forEach((key) => {
          let valor = item[key];
          if (i.key == key) {
            i.valor = valor;
          }
        });
      });
      this.setear_inputs(this.inputs);
      this.configuracion_modal.ruta = `/lab_item_analisis/${evento.item.id}`;
      this.configuracion_modal.tipo_ruta = "put";
      this.configuracion_modal.titulo_boton = "Actualizar";
      this.configuracion_modal.clase_boton = "btn-warning";

      this.$emit("abrir");
    },
    restablecer_inputs() {
      this.cargar_url(this.pagina_actual);
      this.inputs.forEach((i) => {
        i.valor = "";
      });
      this.setear_inputs(this.inputs);
    },
    async editar_parametros(event) {
      this.item_actual = event.item;
      console.table("item actual", this.item_actual);
      await this.cargar_parametros_mp(this.item_actual.mp_tipos_id);
      this.parametros_item = event.item.lab_item_parametros;
      $("#modal_parametros").modal({ show: true });
      //console.log(event);
    },

    async cargar_parametros_mp(mps_id) {
      await this.axios
        .get(
          `${this.api}/configuracion_formulas/mps_id/${mps_id}/cargar_parametros`,
          this.cabeceras_json
        )
        .then((res) => {
          this.parametros_mp = res.data.data;
          console.log("cargo?", res.data);
        })
        .catch((e) => {
          console.log(e);
        });
    },

    async guardar_usuarios() {
      let body = {
        users_ids: this.usuarios_ids,
      };
      await this.axios
        .post(
          `${this.api}/lab_item_parametros/${this.parametro_actual.id}/guardar_usuarios`,
          body,
          this.cabeceras_json
        )
        .then((res) => {
          //console.log(res.data);
          this.alert_modal_correo_clase = "alert-success-1";
          this.alert_modal_correo_mensaje = res.data.mensaje;
          this.alert_modal_correo = true;
          this.cargar("");
        })
        .catch((e) => {
          //console.log(e);
          this.alert_modal_correo_clase = "alert-danger";
          this.alert_modal_correo_mensaje =
            "Ha ocurrido un problema, no se ha podido realizar la accion";
          this.alert_modal_correo = true;
        });
    },

    async configurar_usuarios_correo(p) {
      await this.axios
        .get(`${this.api}/lab_item_parametros/${p.id}`, this.cabeceras_json)
        .then((res) => {
          this.destinatarios_ids = res.data.data.destinatarios_ids;
          ////console.log(this.destinatarios_ids);
        })
        .catch((e) => {
          //console.log(e);
        });
      //this.usuarios_ids = p.usuarios_correo_ids;
      await this.resetear_destinatarios_correos();
      this.parametro_actual = p;
      //this.destinatarios_ids = p.destinatarios_ids;
      await this.setear_destinatarios_correos();
      $("#modal_destinatarios").modal({ show: true });
    },

    async configurar_alertas(p) {
      this.parametro_actual = p;
      this.destinatarios_ids = p.destinatarios_ids;
      await this.axios
        .get(
          `${this.api}/lab_item_parametros/${p.id}/cargar_alertas`,
          this.cabeceras_json
        )
        .then((res) => {
          this.alertas = res.data.data;
          ////console.log(res.data);
        })
        .catch((e) => {
          //console.log(e);
        });
      //this.usuarios_ids = p.usuarios_correo_ids;

      $("#modal_alertas").modal({ show: true });
    },

    agregar_alerta() {
      this.alertas.push({
        id: null,
        minimo: null,
        maximo: null,
        empresas_ids: [],
      });
    },

    async eliminar_alerta(p, idx) {
      if (p.id != null) {
        await this.axios
          .delete(`${this.api}/lab_alertas/${p.id}`, this.cabeceras_json)
          .then((res) => {
            this.alertas.splice(idx, 1);
          })
          .catch((e) => {
            //console.log(e);
          });
      } else {
        this.alertas.splice(idx, 1);
      }
    },

    async guardar_alertas() {
      let body = {
        alertas: this.alertas,
      };
      await this.axios
        .post(
          `${this.api}/lab_item_parametros/${this.parametro_actual.id}/guardar_alertas`,
          body,
          this.cabeceras_json
        )
        .then((res) => {
          //console.log(res.data);

          this.cargar("");
        })
        .catch((e) => {
          //console.log(e);
        });
    },

    async guardar_destinatarios() {
      let body = {
        destinatarios_ids: this.destinatarios_correos
          .filter((d) => d.check == true)
          .map((d) => d.id),
      };
      await this.axios
        .post(
          `${this.api}/lab_item_parametros/${this.parametro_actual.id}/guardar_destinatarios`,
          body,
          this.cabeceras_json
        )
        .then((res) => {
          //console.log(res.data);

          this.cargar("");
        })
        .catch((e) => {
          //console.log(e);
        });
    },

    resetear_destinatarios_correos() {
      this.destinatarios_correos.forEach((d, idx) => {
        this.$set(this.destinatarios_correos[idx], "check", false);
      });
    },

    setear_destinatarios_correos() {
      this.destinatarios_correos.forEach((d) => {
        let check = this.destinatarios_ids.findIndex((id) => d.id == id);
        if (check != -1) {
          d.check = true;
        }
      });
    },

    async configurar_formula(p) {
      this.parametro_actual = p;
      //this.destinatarios_ids = p.destinatarios_ids;
      /* await this.axios.get(`${this.api}/lab_item_parametros/${p.id}/cargar_alertas`,this.cabeceras_json).then((res)=>{
            
          }).catch((e)=>{
            
          }) */

      $("#modal_formula").modal({ show: true });
    },

    agregar_paso_formula() {
      this.pasos_formula.push({
        lab_parametro_principal: this.parametro_actual.id,
        tipo_valor_1: null,
        tipo_valor_2: null,
        operador: null,
        lab_item_parametros_id1: null,
        lab_item_parametros_id2: null,
        orden: null,
      });
    },

    async guardar_formula() {
      await this.axios
        .post(
          `${this.api}/lab_item_parametros/${this.parametro_actual.id}/guardar_formula`
        )
        .then((res) => {
          console.log("pasos de formula guardados");
        })
        .catch((e) => {
          console.log(e);
        });
    },

    ...mapActions(["inicializar_tabla", "setear_lista", "setear_inputs"]),
  },
  components: {
    "modal-crear-editar": ModalCrearEditar,
    tablita: Tabla,
  },
  computed: {
    ...mapState(["api", "cabeceras_json"]),
    query() {
      let string = "?";
      let and = "";
      let total = this.columnas.length - 1;
      this.columnas.forEach((c, index) => {
        if (index > 0 && string.length > 0) {
          and = "&";
        } else if (index == total) {
          and = "";
        }

        if (c.busqueda != "") {
          string += `${and}${c.key}=${c.busqueda}`;
        }
      });
      return string;
    },
    path() {
      return this.$router.currentRoute.path;
    },
  },
};
</script>
<style>
.form-control {
  height: calc(1em + 1.25rem + 5px);
}
</style>